import { useSnackbar, OptionsObject, ProviderContext, SnackbarMessage } from 'notistack';

/**
 * Imperative entry point to notistack for non-component call sites.
 * Notistack v1 has no top-level `enqueueSnackbar` export, so we capture the
 * live API from `useSnackbar()` via a mounted configurator and expose it
 * through the `SnackbarUtils` object.
 */
const SnackbarUtilsRef: { current: ProviderContext | null } = { current: null };

export const SnackbarUtilsConfigurator = (): null => {
  SnackbarUtilsRef.current = useSnackbar();
  return null;
};

export const SnackbarUtils = {
  enqueue(message: SnackbarMessage, options?: OptionsObject): void {
    SnackbarUtilsRef.current?.enqueueSnackbar(message, options);
  },
  close(key?: string | number): void {
    SnackbarUtilsRef.current?.closeSnackbar(key);
  },
};
